import {
    Box, Button,
    CircularProgress, Container, FormControl, FormControlLabel,
    Grid, IconButton, Input, InputAdornment, InputLabel, MenuItem,
    Paper,
    Radio, RadioGroup,
    Select, Stack,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useDaumPostcodePopup } from 'react-daum-postcode';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { BsFiles, BsSearch, BsUpload } from "react-icons/bs";
import { useNavigate, useParams } from 'react-router-dom';
import Page from 'src/components/Page';
import NewWindow from 'src/utils/newwindow';
import { getBizLicenseMask } from 'src/utils/shop';
import { apiService } from '../../api/axiosClient';
import PageHeader from '../../components/page-header';

const Company = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const [files, setFiles] = useState([])
    const [company, setCompany] = useState({});
    const [list, setList] = useState([]);
    const [staff, setStaff] = useState([]);
    const [companyTax, setCompanyTax] = useState({});
    const [companyQuery, setCompanyQuery] = useState({});
    const {
        control,
        handleSubmit,
        formState: { errors }
    } = useForm()
    const open = useDaumPostcodePopup();
    const inputFile = useRef(null);
    const postBtnRef = useRef(null);
    const [searchCompanyShow, setSearchCompanyShow] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.get(`/users/company/${params.id}`)
            const payload = response.data.data;
            setCompany(payload);
        }

        params.id && fetchData();
    }, [params.id]);

    useEffect(() => {
        const fetchList = async () => {
            const response = await apiService.get(`/users/company_tax/list/${company.com_code}`)
            setList(response.data.list);
        }
        company && fetchList();

    }, [company]);

    useEffect(() => {
        const fetchStaffData = async () => {
            const response = await apiService.get('/staff');

            setStaff(response.data.list);
        }
        fetchStaffData();
    }, []);

    const onSubmit = async (data, e) => {
        e.preventDefault();
        setLoading(true);

        const formData = new FormData();
        for(let key in company) {
            formData.append(key, company[key]);
        }

        if(files) {
            formData.append('file', files);
        }

        const formData2 = new FormData();
        for(let key in companyTax) {
            formData2.append(key, companyTax[key]);
        }
        companyTax.tax_tp || formData2.append('tax_tp', "20");

        // 회사 정보 저장
        await apiService.putFormData(`/users/company/${params.id}`, formData)
        .then(response => {
            toast.success('회사 정보가 변경되었습니다.', { position: "top-right" });
            setLoading(false);
        })
        .catch(error => {
            toast.error('회사 정보 변경에 실패했습니다.', { position: "top-right" });
            setLoading(false);
            console.error(error);
        });
    }

    const findLocation = async () => {
        try {
            // Example API call to fetch latitude and longitude
            const response = await apiService.get('/plugin/navermap', {
                params: {
                    query: company.com_addr1, // Use the main address to search
                },
            });

            const { latitude, longitude } = response.data.data;

            // Update the company state with the new latitude and longitude
            setCompany({
                ...company,
                com_lat: latitude,
                com_lon: longitude,
            });

            toast.success("위치가 성공적으로 업데이트되었습니다.", {
                position: "top-right",
            });
        } catch (error) {
            toast.error("위치 정보를 가져오는 데 실패했습니다.", {
                position: "top-right",
            });
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setCompany({ ...company, bizlicense: file.name }); // Update the company state with the file name
            setFiles(file); // Store the file in state for submission
        }
    };

    const handleFileSearch = (e) => {
        e.preventDefault();
        document.getElementById('file-input').click();
    }

    const handleFileOpen = (e) => {
        e.preventDefault();
        company.com_bizfile && window.open(`${company.com_bizfile}`, '_blank');
    }

    const handleClose = () => {
        postBtnRef.current.disabled = false;
    }

    const handleComplete = (data) => {
        let fullAddress = data.address;
        let extraAddress = '';

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
            }
            fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
        }

        setCompany({ ...company, com_zip: data.zonecode, com_addr1: fullAddress });
    };

    const handleClick = () => {
        postBtnRef.current.disabled = true;
        open({ onComplete: handleComplete, onClose: handleClose });
    };


    const searchCompanyName = async () => {        
        setCompanyQuery({ field: 'com_name', q: company.com_name || ""  });
        setSearchCompanyShow(true);
    }
    
    const searchCompanyCode = async () => {
        setCompanyQuery({ field: 'com_code', q: company.com_code || "" });
        setSearchCompanyShow(true);
    }

    window.companyReceiver = (company) => {
        setCompany({ ...company, 
            com_name: company.com_name, 
            com_code: company.com_code, 
            com_ceo: company.com_ceo, 
            com_sector: company.com_sector, 
            com_field: company.com_field, 
            com_zip: company.com_zip, 
            com_addr1: company.com_addr1, 
            com_addr2: company.com_addr2,
            com_payment: company.com_payment || "선불"
        });
    }

    const handleSearchClose = () => {
        setSearchCompanyShow(false);
    }

    const CompanySearchWindow = () => {
        return (
            searchCompanyShow ? (
            <NewWindow 
                url={`/find/company?field=${companyQuery.field}&q=${companyQuery.q}`} 
                title={"회사 검색"} 
                features = {{ left: '100px', top: '100px', width: '800px', height: '900px'}}
                onUnload={handleSearchClose} /> ) 
            : ""
        )
    }

    const handlePurchaseUpdate = async () => {
        setLoading(true);
        try {
            const response = await apiService.post(`/users/company/purchase_update/${company.com_code}`, {});
            toast.success('구매 매출액 업데이트 되었습니다.', { position: "top-right" });
        } catch (error) {
            toast.error('구매 매출액 업데이트에 실패했습니다.', { position: "top-right" });
        } finally {
            setLoading(false);
        }
    }

    return (
        <Page title="Company">
            <Container>
                <PageHeader
                    title={
                        <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                            <Typography variant='h5' color='#666CFF'>
                                회사 등록
                            </Typography>
                        </Stack>
                    }
                    subtitle={
                        <Typography variant='body2'>
                            모든항목의 회사 정보를 입력해주세요.                            
                        </Typography>
                    }
                />

                <Tooltip sx={{mt:4}} title="회사의 구매 매출액 업데이트">
                    <Button variant="contained" color="info" onClick={handlePurchaseUpdate} >구매 매출액 업데이트</Button>
                </Tooltip>

                <Box component="form" onSubmit={handleSubmit(onSubmit)} id="companyform">
                    <Grid container>                        
                        <Box component="section" sx={{ marginTop: 10 }}>
                            <Typography variant="h5" sx={{ marginBottom: 6 }}>
                                사업자 등록정보
                            </Typography>
                            <Grid container spacing={4}>
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth required>
                                        <InputLabel id='classify'>업체분류</InputLabel>
                                        <Select
                                            label='업체분류'
                                            value={company.com_type || ""}
                                            onChange={(e) => setCompany({ ...company, com_type: e.target.value })}
                                            labelId='classify'
                                        >
                                            <MenuItem value="">선택하세요.</MenuItem>
                                            <MenuItem value="국가연구소">국가연구소</MenuItem>
                                            <MenuItem value="제조업">제조업</MenuItem>
                                            <MenuItem value="학교">학교</MenuItem>
                                            <MenuItem value="도소매">도소매</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth required>
                                        <TextField
                                            label="업체명"
                                            name="com_name"
                                            value={company.com_name || ""}
                                            onChange={(e) => setCompany({ ...company, com_name: e.target.value })}
                                            placeholder="법인명"
                                            InputProps={{
                                                endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton edge="end" onClick={searchCompanyName} sx={{padding: 2, marginRight: 1}}>
                                                        <BsSearch />
                                                    </IconButton>
                                                </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* 사업자등록번호 */}
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth required>
                                        <TextField
                                            label="사업자등록번호"
                                            name="com_code"
                                            value={company.com_code || ""}
                                            onChange={(e) => setCompany({ ...company, com_code: getBizLicenseMask(e) })}
                                            placeholder="사업자등록번호"
                                            InputProps={{
                                                endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton edge="end" onClick={searchCompanyCode} sx={{padding: 2, marginRight: 1}}>
                                                        <BsSearch />
                                                    </IconButton>
                                                </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* 대표자명 */}
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth required>
                                        <TextField
                                            label="대표자명"
                                            name="com_ceo"
                                            value={company.com_ceo || ""}
                                            onChange={(e) => setCompany({ ...company, com_ceo: e.target.value })}
                                            placeholder="대표자명"
                                        />
                                    </FormControl>
                                </Grid>

                                {/* 업태 */}
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth required>
                                    <TextField
                                        label="업태"
                                        name="com_sector"
                                        value={company.com_sector || ""}
                                        onChange={(e) => setCompany({ ...company, com_sector: e.target.value })}
                                        placeholder="업태"
                                    />
                                    </FormControl>
                                </Grid>

                                {/* 종목 */}
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth required>
                                    <TextField
                                        label="종목"
                                        name="com_field"
                                        value={company.com_field || ""}
                                        onChange={(e) => setCompany({ ...company, com_field: e.target.value })}
                                        placeholder="종목"
                                        inputProps={{ maxLength: 30 }}
                                    />
                                    </FormControl>
                                </Grid>

                                {/* 사업자등록증 */}
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth>
                                        <Input type="file" id="file-input" style={{ display: 'none' }} onChange={handleFileChange} inputRef={inputFile} />
                                        <TextField
                                            label="사업자등록증"
                                            name="bizlicense"
                                            value={company.bizlicense || ""}
                                            placeholder="사업자등록증"
                                            InputProps={{
                                                endAdornment: (
                                                <InputAdornment position="end">
                                                    {
                                                        company.com_bizfile && 
                                                        <IconButton color="primary" edge="end" onClick={handleFileOpen} sx={{padding: 2, marginRight: 2}}>
                                                            <BsFiles />
                                                        </IconButton>
                                                    }                                                    
                                                    <IconButton edge="end" ref={postBtnRef} onClick={handleFileSearch} sx={{padding: 2, marginRight: 1}}>
                                                        <BsUpload />
                                                    </IconButton>
                                                </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* 사업자등록소재지 */}
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth required>
                                    <TextField
                                        label="사업자등록소재지"
                                        name="com_zip"
                                        value={company.com_zip || ""}
                                        placeholder="사업자등록소재지"
                                        InputProps={{
                                            endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton edge="end" ref={postBtnRef} onClick={handleClick} sx={{padding: 2, marginRight: 1}}>
                                                    <BsSearch />
                                                </IconButton>
                                            </InputAdornment>
                                            ),
                                        }}
                                    />
                                    </FormControl>
                                </Grid>

                                {/* 주요주소 */}
                                <Grid item xs={12}>
                                    <FormControl fullWidth required>
                                    <TextField
                                        label="주요주소"
                                        name="com_addr1"
                                        value={company.com_addr1 || ""}
                                        InputProps={{ readOnly: true }}
                                        placeholder="주요주소"
                                    />
                                    </FormControl>
                                </Grid>

                                {/* 세부주소 */}
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                    <TextField
                                        label="세부주소"
                                        name="com_addr2"
                                        value={company.com_addr2 || ""}
                                        onChange={(e) => setCompany({ ...company, com_addr2: e.target.value })}
                                        placeholder="세부주소"
                                        inputProps={{ maxLength: 30 }}
                                    />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label="위도"
                                            disabled
                                            name="com_lat"
                                            value={company.com_lat || ""}
                                            onChange={(e) => setCompany({ ...company, com_lat: e.target.value })}
                                            placeholder="위도"
                                            inputProps={{ maxLength: 30 }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label="경도"
                                            disabled
                                            name="com_lon"
                                            value={company.com_lon || ""}
                                            onChange={(e) => setCompany({ ...company, com_lon: e.target.value })}
                                            placeholder="경도"
                                            inputProps={{ maxLength: 30 }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Button variant='contained' color='warning' sx={{ height: '100%' }} onClick={findLocation}>위치찾기</Button>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <FormControl fullWidth required>
                                        <InputLabel id='discount'>구매 할인율</InputLabel>
                                        <Select
                                            label='구매 할인율'
                                            value={company.com_discount || ""}
                                            onChange={(e) => setCompany({ ...company, com_discount: e.target.value })}                                            
                                            labelId='staff'
                                        >
                                            <MenuItem value="">선택하세요.</MenuItem>
                                            <MenuItem value="0">0%</MenuItem>
                                            <MenuItem value="3">3%</MenuItem>
                                            <MenuItem value="5">5%</MenuItem>
                                            <MenuItem value="10">10%</MenuItem>
                                            <MenuItem value="12">12%</MenuItem>
                                            <MenuItem value="15">15%</MenuItem>
                                            <MenuItem value="20">20%</MenuItem>
                                            <MenuItem value="25">25%</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <FormControl component="fieldset" fullWidth required>
                                        <InputLabel id='staff'>담당자</InputLabel>
                                        <Select
                                            label='담당자'
                                            value={company.com_charge || ""}
                                            onChange={(e) => setCompany({ ...company, com_charge: e.target.value })}
                                            labelId='staff'
                                        >
                                            {
                                                staff.map((item, index) => (
                                                    <MenuItem key={index} value={item.username}>{item.username}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <FormControl fullWidth required>
                                        <InputLabel id='payment'>결제 조건</InputLabel>
                                        <Select
                                            label='결제 조건'
                                            value={company.com_payment || "선불"}
                                            onChange={(e) => setCompany({ ...company, com_payment: e.target.value })}
                                            labelId='payment'
                                        >
                                            <MenuItem value="선불">선불</MenuItem>
                                            <MenuItem value="후불">후불</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Typography variant="h5" sx={{ marginTop: 8, marginBottom: 2 }}>
                                결제 정보
                            </Typography>
                            <Grid container spacing={4}>                                                        
                                <Grid item xs={12} md={8}>
                                    <Stack direction="row" alignItems="center" spacing={6}>
                                        <Typography>
                                            세금계산서 발행구분
                                        </Typography>
                                        <RadioGroup
                                            row
                                            value={companyTax.tax_tp || "20"}
                                            onChange={(e) =>
                                                setCompanyTax({
                                                    ...companyTax, tax_tp: e.target.value,
                                                })
                                            }
                                            sx={{ ml: 2 }}
                                        >
                                            <FormControlLabel
                                                value="10"
                                                control={<Radio />}
                                                label="발행"
                                            />
                                            <FormControlLabel
                                                value="20"
                                                control={<Radio />}
                                                label="카드결제"
                                            />
                                        </RadioGroup>
                                    </Stack>
                                </Grid>

                            </Grid>
                            <TableContainer component={Paper} sx={{ marginTop: 4 }}>
                            {
                                list?.length > 0 && 
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>구매담당자(회원ID)</TableCell>
                                                <TableCell>세금계산서 담당자</TableCell>
                                                <TableCell>담당자 연락처</TableCell>
                                                <TableCell>담당자 이메일</TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {
                                            list.map((item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{item.username}</TableCell>
                                                    <TableCell>{item.tax_charge}</TableCell>
                                                    <TableCell>{item.tax_phone_mobile}</TableCell>
                                                    <TableCell>{item.tax_email}</TableCell>
                                                    <TableCell align="center">
                                                        <Button variant="contained" color="error" sx={{ color: '#fff !important'}} onClick={() => {}} >삭제</Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        }
                                        </TableBody>
                                    </Table>
                            }
                            </TableContainer>
                        </Box>
                    </Grid>
                </Box>

                <Stack direction="row" spacing={2} sx={{ py: 16, justifyContent: 'center' }}>
                    <Button type="submit" form="companyform" variant='contained'>
                        {loading ? (
                        <CircularProgress
                            sx={{
                            color: 'common.white',
                            width: '20px !important',
                            height: '20px !important',
                            mr: theme => theme.spacing(2)
                            }}
                        />
                        ) : null}
                        수정
                    </Button>
                    <Button variant='outlined' color='secondary' onClick={() => {navigate(-1)}}>
                        취소
                    </Button>
                </Stack>
            </Container>            
            <CompanySearchWindow />
            
        </Page>
    )
}

export default Company